var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconTimesheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.4,
    fill: "#FFFFFF",
    stroke: "#193C6D",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.2785V25.3337H13.9163L22.5173 16.3231L19.601 13.2679L11 22.2785ZM24.7725 13.9604C25.0758 13.6427 25.0758 13.1294 24.7725 12.8117L22.9528 10.9053C22.6495 10.5876 22.1596 10.5876 21.8563 10.9053L20.4331 12.3962L23.3494 15.4513L24.7725 13.9604Z",
    fill: "#193C6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconTimesheet);
export default __webpack_public_path__ + "static/media/editIconTimesheet.72fc277f432f93afeb350154f06d474e.svg";
export { ForwardRef as ReactComponent };